import { render, staticRenderFns } from "./symptomSurveyStatusDetail.vue?vue&type=template&id=6050b545"
import script from "./symptomSurveyStatusDetail.vue?vue&type=script&lang=js"
export * from "./symptomSurveyStatusDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6050b545')) {
      api.createRecord('6050b545', component.options)
    } else {
      api.reload('6050b545', component.options)
    }
    module.hot.accept("./symptomSurveyStatusDetail.vue?vue&type=template&id=6050b545", function () {
      api.rerender('6050b545', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/symptomSurveyStatusDetail.vue"
export default component.exports